import { InjectionToken } from '@angular/core';
import { EntityMap } from '../../model';
import { Occ } from '../../occ';
import { Converter } from '../../util/converter.service';

export const CATALOG_KEYS_NORMALIZER = new InjectionToken<Converter<Occ.Map<string>, EntityMap<string>>>('CatalogKeysNormalizer');
